import * as React from "react";
import { Tooltip, Position, Button } from "@focus/focusUI";
import "./ListButton.scss";
export const ListButton = ({ readOnly, disabled, id, iconName, content, onClick, }) => {
    const isReadOnly = typeof readOnly !== "undefined" && readOnly;
    const isDisabled = typeof disabled !== "undefined" && disabled;
    const htmlContent = React.createElement("span", null, content);
    return (React.createElement("div", { className: "list-table-button-item" },
        React.createElement(Tooltip, { content: htmlContent, position: Position.TOP, disabled: isDisabled || isReadOnly },
            React.createElement(Button, { "data-testid": id, type: "button", icon: iconName, minimal: true, onClick: onClick, id: id, disabled: isDisabled || isReadOnly }))));
};
//# sourceMappingURL=ListButton.js.map